import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export
export const navigationSkipLink = css`
  ${media('>=tablet')} {
    display: none;
  }
`;
